// get container
let $ = jQuery;
document.addEventListener('DOMContentLoaded', function () {
	const containers = document.getElementsByClassName('recommendation-slider');

	// Early return if no containers exist
	if (!containers.length) return;

	// Track initialized swiper elements to prevent duplicate instances
	const initializedSwipers = new WeakSet();

	function initSingleSwiper(swiperContainer, swiperData) {
		// Skip if already initialized
		if (initializedSwipers.has(swiperContainer)) return;
		if (swiperContainer.classList.contains('swiper-initialized')) return;

		// Check if it has products to display
		const productsList = swiperContainer.querySelector('ul.products');
		if (!productsList || !productsList.children.length) return;

		$(swiperContainer).addClass('swiper');
		$(swiperContainer).find('ul.products').addClass('swiper-wrapper');
		$(swiperContainer).find('li.product').addClass('swiper-slide');
		$(swiperContainer).find('ul.products').before(
			'<div class="prl_swiper_nav"><div class="swiper-button-next"><span> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.0663 10.6661L4.87387 1.47371L5.58097 0.766602L15.4805 10.6661L5.58097 20.5656L4.87387 19.8585L14.0663 10.6661Z" fill="#211710"></path></svg> </span></div><div class="swiper-button-prev"><span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.93375 10.6661L15.1261 1.47371L14.419 0.766602L4.51953 10.6661L14.419 20.5656L15.1261 19.8585L5.93375 10.6661Z" fill="#211710"></path></svg></span></div></div>');

		// Use DOM element references to prevent conflicts with other Swipers
		const nextBtn = swiperContainer.querySelector('.swiper-button-next');
		const prevBtn = swiperContainer.querySelector('.swiper-button-prev');
		const paginationEl = swiperContainer.querySelector('.swiper-pagination');

		new Swiper(swiperContainer, {
			slidesPerView: swiperData.perViewSlides ?? '4',
			spaceBetween: swiperData.slideSpace,
			speed: swiperData.sliderSpeed,
			loop: true,
			effect: 'slide',
			autoplay: {
				enabled: swiperData.matatSliderAutoPlay,
				delay: 100000000,
				pauseOnMouseEnter: true
			},
			pagination: {
				el: paginationEl,
				clickable: true,
				dynamicBullets: false,
				enabled: swiperData.paginationEnabled,
			},
			navigation: {
				enabled: swiperData.navigationEnabled,
				nextEl: nextBtn,
				prevEl: prevBtn,
			}
		});

		// Mark as initialized
		initializedSwipers.add(swiperContainer);
	}

	function initSlider(containers) {
		for (let i = 0; i < containers.length; i++) {
			const container = containers[i];

			const swiperDataAttr = container.getAttribute('data-sliderdata');
			if (!swiperDataAttr) continue;

			let swiperData;
			try {
				swiperData = JSON.parse(swiperDataAttr);
			} catch (e) {
				continue;
			}

			// Get ALL .wc-prl-recommendations elements inside this container
			const swiperContainers = container.querySelectorAll('.wc-prl-recommendations');
			if (!swiperContainers.length) continue;

			// Initialize Swiper for each .wc-prl-recommendations element
			swiperContainers.forEach(function(swiperContainer) {
				initSingleSwiper(swiperContainer, swiperData);
			});
		}
	}

	// Debounce function for resize handler
	function debounce(func, wait) {
		let timeout;
		return function() {
			clearTimeout(timeout);
			timeout = setTimeout(func, wait);
		};
	}

	function handleRVPSwiper() {
		const screenWidth = window.innerWidth;
		if (screenWidth >= 1024) {
			initSlider(containers);
		}
	}

	// MutationObserver to detect when PRL plugin adds content dynamically
	const observer = new MutationObserver(function(mutations) {
		if (window.innerWidth < 1024) return;

		mutations.forEach(function(mutation) {
			mutation.addedNodes.forEach(function(node) {
				if (node.nodeType !== 1) return; // Skip non-element nodes

				// Check if the added node is a .wc-prl-recommendations or contains one
				if (node.classList && node.classList.contains('wc-prl-recommendations')) {
					// Find parent container and init
					const container = node.closest('.recommendation-slider');
					if (container) {
						const swiperDataAttr = container.getAttribute('data-sliderdata');
						if (swiperDataAttr) {
							try {
								const swiperData = JSON.parse(swiperDataAttr);
								initSingleSwiper(node, swiperData);
							} catch (e) {}
						}
					}
				} else if (node.querySelectorAll) {
					// Check if added node contains .wc-prl-recommendations
					const prlElements = node.querySelectorAll('.wc-prl-recommendations');
					prlElements.forEach(function(prlEl) {
						const container = prlEl.closest('.recommendation-slider');
						if (container) {
							const swiperDataAttr = container.getAttribute('data-sliderdata');
							if (swiperDataAttr) {
								try {
									const swiperData = JSON.parse(swiperDataAttr);
									initSingleSwiper(prlEl, swiperData);
								} catch (e) {}
							}
						}
					});
				}
			});
		});
	});

	// Observe each recommendation-slider container for changes
	for (let i = 0; i < containers.length; i++) {
		observer.observe(containers[i], { childList: true, subtree: true });
	}

	// Initial load attempts
	window.addEventListener('load', handleRVPSwiper);
	window.addEventListener('resize', debounce(handleRVPSwiper, 150));

	// Also try after a short delay in case AJAX loads quickly
	setTimeout(handleRVPSwiper, 500);
	setTimeout(handleRVPSwiper, 1500);

});
